import { render } from "./Deliverables.vue?vue&type=template&id=1b7875f1&scoped=true"
import script from "./Deliverables.vue?vue&type=script&lang=js"
export * from "./Deliverables.vue?vue&type=script&lang=js"

import "./Deliverables.vue?vue&type=style&index=0&id=1b7875f1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7875f1"]])

export default __exports__